import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ForestProductDto } from '@system-shared/classes.dto';

export enum PermitSteps {
  ChooseForest = 0,
  PermitInformation,
  RulesAgreement,
  PurchasePermit,
  Payment,
  PurchaseConfirmation
}

@Component({
    selector: 'app-buy-permits',
    templateUrl: './buy-permits.component.html',
    styleUrls: ['./buy-permits.component.scss'],
    standalone: false
})
export class BuyPermitsComponent implements OnInit {
  forest: ForestProductDto;
  product: any;
  permitSteps = PermitSteps;
  permitStepLabels = ['Choose Forest', 'Permit Information', 'Rules & Agreement', 'Purchase Permit', 'Payment', 'Purchase Confirmation'];
  currentStepIndex = this.permitSteps.PermitInformation;
  permit: any = {};
  showAlert = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.forest = data.forest;
      this.product = this.forest.product;
      if (!this.product.permit_available || !this.forest.active) {
        this.router.navigate(['/']);
      }
      if (data.forest.code === '0803') {
        this.showAlert = true;
      }
    });
  }

  prev() {
    this.currentStepIndex--;
  }

  next() {
    this.currentStepIndex++;
  }

}
